<div class="mx-3">

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2 class="mb-0">{{ 'REPORT.TITLE' | translate }}</h2>
    @if (user?.roles.includes('ADMIN') || user?.roles.includes('EDITOR')) {
      <ntr-add-button [openView]="'report/add-edit'"
        >
      </ntr-add-button>
    }
  </div>

  <hr class="mt-0"/>

  <!-- Card list -->
  <div class="d-flex flex-column gap-2">
    @for (report of reports; track report; let i = $index) {
      <div class="report-card d-flex align-items-center gap-3 px-3 py-3"
        (click)="reportView(report.id)"
        style="cursor:pointer;">
        <!-- Gradient icon -->
        <div class="report-card-icon flex-shrink-0"
          [style.background]="getGradient(i)">
          <lucide-icon name="chart-line" style="color:var(--fg-on-navy);" size="20"></lucide-icon>
        </div>
        <!-- Name + metadata -->
        <div class="flex-grow-1 overflow-hidden">
          <div class="fw-semibold text-truncate report-card-name">{{ report.name }}</div>
          <div class="report-card-meta text-muted">
            {{ report.dataSets?.length || 0 }} datasets
            &nbsp;·&nbsp;
            {{ report.columns?.length || 0 }} columns
          </div>
        </div>
        <!-- Delete -->
        <button type="button"
          class="btn btn-outline-danger btn-sm report-card-delete flex-shrink-0"
          (click)="delete(report.id); $event.stopPropagation()">
          <lucide-icon name="trash-2" size="13"></lucide-icon>
          <span class="ms-1">Delete</span>
        </button>
      </div>
    }

    <!-- Empty state -->
    @if (!reports?.length) {
      <div class="report-empty text-center text-muted py-5">
        <lucide-icon name="file-text" class="mb-2 d-block mx-auto" size="32"></lucide-icon>
        No reports found
      </div>
    }
  </div>

</div>
